import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { cn } from '#client/lib/cn';
import type { ButtonSize, ButtonVariant } from './Button';

interface ButtonLinkProps {
  /** An in-app route. Files and API downloads stay plain `<a>` elements. */
  to: string;
  variant?: ButtonVariant | undefined;
  size?: ButtonSize | undefined;
  children: ReactNode;
}

/**
 * A link that looks like a button, for navigation inside the app.
 *
 * A router link rather than `<a href>`, so following it keeps the session's
 * state instead of reloading the whole page.
 */
export function ButtonLink({ to, variant = 'secondary', size = 'md', children }: ButtonLinkProps) {
  return (
    <Link className={cn('c-button', `c-button--${variant}`, `c-button--${size}`)} to={to}>
      {children}
    </Link>
  );
}
